import React, { useEffect } from "react";
import NavBar from "../common/NavBar";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const FerienparkHahnenklee = () => {
  const { t } = useTranslation();

  // Determine if user belongs to "Owner" group
  useEffect(() => {
    const rawGroups = localStorage.getItem("groups");
    let storedGroups = [];

    if (rawGroups) {
      try {
        const parsed = JSON.parse(rawGroups);
        storedGroups = Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        storedGroups = [rawGroups];
      }
    }

    const isOwner = storedGroups.some((group) => String(group).trim() === "Owners");
    if (isOwner) { /* owner-specific logic could go here */ }
  }, []);

  // Static block structure, texts via translation
  const blocks = [
    {
      title: t("ferienpark.block1.title"),
      description: t("ferienpark.block1.description"),
      image: "/static/images/wifi.png",
    },
    {
      title: t("ferienpark.block2.title"),
      description: t("ferienpark.block2.description"),
      image: "/static/images/minigolf.jpg",
    },
    {
      title: t("ferienpark.block3.title"),
      description: t("ferienpark.block3.description"),
      image: "/static/images/spielplatz.jpg",
    },
    {
      title: t("ferienpark.block4.title"),
      description: t("ferienpark.block4.description"),
      image: "/static/images/trolley.jpg",
    },
    {
      title: t("ferienpark.block5.title"),
      description: t("ferienpark.block5.description"),
      image: "/static/images/winter.png",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <NavBar />

      {/* Hero / Title Section */}
      <div className="flex flex-col items-center text-center mt-16 px-6">
        <h1 className="text-4xl font-bold mb-6 text-gray-800">
          {t("ferienpark_hahnenklee")}
        </h1>
        <p className="max-w-3xl text-gray-600 leading-relaxed text-lg">
          {t("ferienpark.main_description")}
        </p>
      </div>

      {/* 2-column blocks */}
      <div className="mt-16 space-y-12 px-6 md:px-20">
        {blocks.map((block, index) => (
          <div
            key={index}
            className={`grid md:grid-cols-2 gap-8 items-center ${
              index % 2 === 1 ? "md:flex-row-reverse" : ""
            }`}
          >
            <div className="text-gray-700">
              <h2 className="text-2xl font-semibold mb-4">{block.title}</h2>
              <p className="leading-relaxed">{block.description}</p>
            </div>
            <div className="flex justify-center">
              <img
                src={block.image}
                alt={block.title}
                className="rounded-2xl shadow-lg w-full md:w-[480px] h-auto object-cover"
              />
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default FerienparkHahnenklee;
